import SelectableContainer from "./SelectableContainer";
import { Row, Col } from "./Flexbox";
import Text from "./Text";
import { Controller, useWatch } from "react-hook-form";

const PROCESS_MAP = {
    caja: [{label: "Diseño", key: "design"}, {label: "CTP", key: "ctp"}, {label: "Corte", key: "cut"}, {label: "Preparación tinta", key: "inkMix"},{label: "Positivo", key: "positive"}, {label: "Cálculo clicks 1", key: "clickCharge1"}, {label: "Cálculo clicks 2", key: "clickCharge2"}],
    plana: [{label: "Diseño", key: "design"}, {label: "CTP", key: "ctp"}, {label: "Corte", key: "cut"}, {label: "Preparación tinta", key: "inkMix"},{label: "Positivo", key: "positive"}, {label: "Cálculo clicks 1", key: "clickCharge1"}, {label: "Cálculo clicks 2", key: "clickCharge2"},  {label: "Corte figura", key: "shapeCut"}],
    flexo: [{label: "Diseño", key: "design"}, {label: "CTP", key: "ctp"}, {label: "Corte", key: "cut"}, {label: "Preparación tinta", key: "inkMix"},{label: "Positivo", key: "positive"}, {label: "Cálculo clicks 1", key: "clickCharge1"}, {label: "Cálculo clicks 2", key: "clickCharge2"}, {label: "Químicos", key: "chemicals"}, {label: "Corte figura", key: "shapeCut"}]
}

const ProductiveProcess = ({theme, control}) => {

    const format = useWatch({control, name: "format"}); //Get the value of the format parameter
    
    const processList = PROCESS_MAP[format?.toLowerCase()] || [];    

    const handleToggle = (currentArray, key, onChange) => {
        const arr = currentArray || [];
        if (arr.includes(key)) {
            onChange(arr.filter((k) => k !== key));
        } else {
            onChange([...arr, key]);
        }
    }

    return (
        <Col style={{width: '100%', justifyContent: 'space-between', marginTop: 64}}>
            <Col style={{width: '100%', justifyContent: 'start', alignItems: 'start'}}>
                <Text style={{marginBottom: 5}} color={theme.Black} size={15} weight={"extrabold"}>Procesos productivos</Text>
                <Controller name="activeProcesses" control={control} render={({field: {value = [], onChange}}) => (
                    <Row style={{flexWrap: 'wrap', justifyContent: 'start', marginTop: 16}}>
                        {processList.map((item) => (
                            <SelectableContainer key={item.key} theme={theme} text={item.label} active={value?.includes(item.key)} onClick={() => handleToggle(value, item.key, onChange)}/>
                        ))}          
                    </Row>
                )}/>
            </Col>
        </Col>
    )
}

export default ProductiveProcess;